import { render, staticRenderFns } from "./FonteForm.vue?vue&type=template&id=c0589a5a&scoped=true"
import script from "./FonteForm.vue?vue&type=script&lang=js"
export * from "./FonteForm.vue?vue&type=script&lang=js"
import style0 from "./FonteForm.vue?vue&type=style&index=0&id=c0589a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0589a5a",
  null
  
)

export default component.exports